// defineCustomElementWithStyles.js
import { defineCustomElement as VueDefineCustomElement, h, createApp, getCurrentInstance } from 'vue'

const getNearestElementParent = (el) => {
    while (el?.nodeType !== 1 /* ELEMENT */) {
        el = el.parentElement
    }
    return el
}

export const defineCustomElement = (component, { plugins = [] }) =>
    VueDefineCustomElement({
        props: component.props,
        render: () => h(component),
        setup(props) {
            const app = createApp(component)

            // install plugins
            plugins.forEach(app.use)

            app.mixin({
                mounted() {
                    const insertStyles = (styles) => {
                        if (styles?.length) {
                            this.__style = document.createElement('style')
                            this.__style.innerText = styles.join().replace(/\n/g, '')
                            getNearestElementParent(this.$el).prepend(this.__style)
                        }
                    }

                    try {
                        // load own styles
                        insertStyles(this.$?.type.styles)
                    } catch (error) {
                        // eslint-disable-next-line no-debugger
                        debugger;
                        console.log("TICK: could not provide styling for main element")
                    }


                    try {
                        // load styles of child components
                        if (this.$options.components) {
                            for (const comp of Object.values(this.$options.components)) {
                                insertStyles((comp as any).styles)
                            }
                        }
                    } catch (error) {
                        console.log("TICK: could not provide styling for child elements")
                    }



                },
                unmounted() {
                    this.__style?.remove()
                },
            })

            const inst = getCurrentInstance()
            Object.assign(inst.appContext, app._context)
            Object.assign((inst as any).provides, app._context.provides)

            return () => h(component, props)
        },
    })

// export const defineCustomElement = (component, { plugins = [] }) =>
//     VueDefineCustomElement({
//         props: component.props,
//         setup(props) {
//             const app = createApp(component)

//             // install plugins
//             plugins.forEach(app.use)

//             app.mixin({
//                 mounted() {
//                     const insertStyles = (styles) => {
//                         if (styles?.length) {
//                             this.__style = document.createElement('style')
//                             this.__style.innerText = styles.join().replace(/\n/g, '')
//                             getNearestElementParent(this.$el).prepend(this.__style)
//                         }
//                     }

//                     insertStyles(this.$?.type.styles)
//                     if (this.$options.components) {
//                         for (const comp of Object.values(this.$options.components)) {
//                             insertStyles((comp as any).styles);
//                         }
//                     }
//                 },
//                 unmounted() {
//                     this.__style?.remove();
//                 },
//             })

//             const inst = getCurrentInstance()
//             Object.assign(inst.appContext, app._context)

//             return () => h(component, props)
//         },
//     })